import React from "react";


const OrderConfirmation = () => {
    
    return (
        <div>
            <div>OrderConfirmation</div>
            <p>Thanks for placing an order</p>
        </div>
    );
};

export default OrderConfirmation;